import { useLocation, useNavigate } from "react-router-dom";
import { replaceLocaleInPathname } from "@/config/site";
import { LOCALES, LOCALE_NATIVE_LABELS, type Locale } from "@/i18n/types";
import { useI18n } from "@/i18n/I18nContext";

type Props = {
  className?: string;
};

export function LanguageSwitcher({ className }: Props) {
  const { locale, setLocale, messages } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <select
      aria-label={messages.header.languageAria}
      value={locale}
      onChange={(event) => {
        const next = event.target.value as Locale;
        setLocale(next);
        const nextPath = replaceLocaleInPathname(location.pathname, next);
        navigate(`${nextPath}${location.search}${location.hash}`);
      }}
      className={
        className ??
        "rounded-xl border border-gray-200 bg-white px-2 py-2 text-sm text-gray-800 shadow-sm outline-none transition-colors hover:border-gray-300 focus-visible:border-[#4CAF50] focus-visible:ring-2 focus-visible:ring-[#4CAF50]/30"
      }
    >
      {LOCALES.map((loc) => (
        <option key={loc} value={loc}>
          {LOCALE_NATIVE_LABELS[loc]}
        </option>
      ))}
    </select>
  );
}
